import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type JozunaProgramState = {
  JozunaSelectedProgram: {
    id: string | any;
    title: string | any;
    description: string | any;
  } | null;
};

const initialState: JozunaProgramState = {
  JozunaSelectedProgram: null,
};

const JozunaProgramSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    setJozunaSelectedProgram(
      state,
      action: PayloadAction<JozunaProgramState["JozunaSelectedProgram"]>,
    ) {
      state.JozunaSelectedProgram = action.payload;
    },
    clearJozunaSelectedProgram(state) {
      state.JozunaSelectedProgram = null;
    },
  },
});

export const { setJozunaSelectedProgram, clearJozunaSelectedProgram } =
  JozunaProgramSlice.actions;
export default JozunaProgramSlice.reducer;
